module.exports = __webpack_public_path__ + "img/Loading_r_29.20c4c2b0.png";